var map = {
	"./music-instructions.json": 5499,
	"./music-library-intro2024.json": 5500,
	"./music-library-launch2024.json": 5501,
	"./music-progression.json": 5502,
	"./startSourcesAdvanced.json": 5503,
	"./startSourcesSimple.json": 5504,
	"./startSourcesSimple2.json": 5505,
	"./startSourcesTracks.json": 5506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5062;